import React from 'react';
import PropTypes from 'prop-types';

const GiftingBrandRefreshFaqBlock = ({ children }) => (
  <section
    className="w-full bg-brandRefresh-background-primary px-4 py-12 md:px-[60px] md:py-20"
    data-testid="gifting-brand-refresh-faq-block"
  >
    <div className="mx-auto flex w-full max-w-[1320px] flex-col items-center gap-14 md:gap-[72px]">
      {children}
    </div>
  </section>
);

GiftingBrandRefreshFaqBlock.propTypes = {
  children: PropTypes.node,
};

GiftingBrandRefreshFaqBlock.defaultProps = {
  children: null,
};

export default GiftingBrandRefreshFaqBlock;
